export default function cookie(name: string, value?: any, options?: any) {
  if (arguments.length < 2) return get(name);
  set(name, value, options);
}

function set(name: string, value: any, options: any = {}) {
  let str = `${encode(name)}=${encode(value)}`;

  if (value === null) options.maxage = -1;

  if (options.maxage) {
    options.expires = new Date(Number(new Date()) + options.maxage);
  }

  str += `; path=/`;
  if (options.domain) str += `; domain=${options.domain}`;
  if (options.expires) str += `; expires=${options.expires.toUTCString()}`;
  if (options.secure) str += '; secure';

  document.cookie = str;
}

function get(name: string) {
  const cookies: { [key: string]: any } = parse(document.cookie);
  return name ? cookies[name] : cookies;
}

function parse(str: string) {
  const obj: { [key: string]: any } = {};
  let pairs: string[] = str.split(/ *; */);

  if (!pairs[0]) return obj;

  for (let pair of pairs) {
    (pair as any) = pair.split('=');
    obj[decode(pair[0]) as string] = decode(pair[1]);
  }
  return obj;
}

function encode(value: any) {
  try {
    return encodeURIComponent(value);
  } catch (e) {
    return null;
  }
}

function decode(value: any) {
  try {
    return decodeURIComponent(value);
  } catch (e) {
    return null;
  }
}

export function clearCookie() {
  const d = new Date();
  d.setTime(-1000); // 设置时间
  const data = document.cookie;
  const dataArray = data.split('; ');
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < dataArray.length; i++) {
    const letName = dataArray[i].split('=');
    document.cookie = `${letName[0]}=''; expires=${d.toString()}`;
  }
}
